<template>
    <div>
        <compWrapper title="基础信息" theme="primary">
            <compFormQuery
                v-if="type=='query'"
                class="margin-top-15 margin-right-15"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
				placeholder="--"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
            />

            <template slot="footer" v-if="type!='query'">
				<vButton class="margin-right-10" theme="primary" @click="submit">保存为草稿</vButton>
                <vButton class="margin-right-10" theme="success" @click="submitexamine">提交审核</vButton>
				<vButton class="margin-right-10" @click="cancel">返回</vButton>
			</template>
        </compWrapper>
        <compWrapper title="事务明细" theme="info">
			<vForm v-if="type!='query'" class="margin-left-15 margin-top-15" :model="workData">
                <vFormItem label-width="auto" inline label="事务项" :rules="required" prop="workOrderTypeId">
					<vSelect v-model="workData.workOrderTypeId" filterable clearable @on-focus="checkWarehouse" @on-change="resetNumber">
                        <vOption v-for="(item,index) in this.workList" :key="index" :value="item.value">{{item.label}}</vOption>
                    </vSelect>
				</vFormItem>
				<vFormItem label-width="auto" inline label="ERP SKU:">
					<vInput v-model="workData.sku" readonly suffix="search" @on-icon-click="handleSkuErp"></vInput>
				</vFormItem>
				<vFormItem label-width="auto" inline :label="$t('global.common.quantity',{defaultValue:'数量'})">
					<vInputNumber v-if="workData.workOrderTypeId == 7" clearable v-model="workData.qty" :min="0.5" :step="0.5" />
					<vInputNumber v-else clearable v-model="workData.qty" :min="1" />
				</vFormItem>
				<vFormItem label-width="auto" inline :label="$t('global.common.notes', { defaultValue: '备注' })">
					<vInput clearable v-model="workData.remark" />
				</vFormItem>
				<vButtonGroup class="inline margin-left-10">
					<vButton
						theme="primary"
						@click="addItem(workData)"
					>{{$t('global.common.add',{defaultValue:'添加'})}}</vButton>
					<vButton
						theme="info"
						@click="handleUploadData"
					>{{$t('global.common.import',{defaultValue:'导入'})}}</vButton>
				</vButtonGroup>
				<vButtonGroup >
					<vButton theme="warning" @click="removeItems">{{$t('global.common.delete',{defaultValue:'删除'})}}</vButton>
					<vButton theme="error" @click="clearAll">{{$tc('global.common.clear',2,{defaultValue:'清空'})}}</vButton>
				</vButtonGroup>
			</vForm>
            <vTableSimple
                style="max-height:200px;overflow:auto"
                class="margin-15"
                :columns="columns"
                :data="dataList"
                @on-check-change="handleCheckData"
            ></vTableSimple>
        </compWrapper>

        <compWrapper title="附件信息" theme="success">
            <div v-if="formData.workOrderPlanStatus == 0 || formData.workOrderPlanStatus == 10 || formData.workOrderPlanStatus == 15 || formData.workOrderPlanStatus == 20 || type=='add'" class="margin-top-15 margin-left-15">
                <vButton theme="primary" @click="addExcel">添加</vButton>
				<vButton class="margin-left-10" @click="deleteExcel">删除</vButton>
				<vButton class="margin-left-10" v-if="formData.workOrderPlanStatus == 20" theme="info" @click="repushattach">重推附件</vButton>
            </div>
            <vTableSimple
                style="max-height:200px;overflow:auto"
                class="margin-15"
                :columns="workcolumns"
                :data="workdataList"
				@on-check-change="handleExcelCheckData"
            ></vTableSimple>
        </compWrapper>
        <compPhotoLog v-if="type==='query'" v-bind="photoData"></compPhotoLog>
		<compWrapper title="操作历史" theme="gray" v-if="type=='query'">
			<compLog :data="opLogList" :columns="getLogcolumns"></compLog>
			<div class="text-right" >
				<vButton class="margin-right-10" v-if="(difference=='detail' && (formData.workOrderPlanStatus == 0 || formData.workOrderPlanStatus == 15)) || (difference=='manage' && (formData.workOrderPlanStatus == 0 || formData.workOrderPlanStatus == 15))" theme="success" @click="submitexamine">提交审核</vButton>
				<vButton class="margin-right-10" v-if="(formData.workOrderPlanStatus == 10) && checkInfo" theme="info" @click="examine">审核</vButton>
				<vButton class="margin-right-10" v-if="(difference=='detail' && formData.workOrderPlanStatus == 10)" theme="error" @click="revokeAudit">撤销审核</vButton>
				<vButton class="margin-right-10" v-if="(formData.workOrderPlanStatus == 20 || formData.workOrderPlanStatus == 30) && compeleteInfo" theme="warning" @click="compelete">完成</vButton>
				<vButton class="margin-right-10" v-if="(difference=='detail' && formData.workOrderPlanStatus == 20) || (difference=='manage' && formData.workOrderPlanStatus == 20)" theme="info" @click="repushware">重推仓库</vButton>

				<vButton class="margin-right-10" v-if="(this.getErrorStatus!= 99999)" theme="success" @click="this.errorReprocess">{{this.$t('global.common.reprocess', { defaultValue: '重处理' })}}</vButton>
                <vButton class="margin-right-10" v-if="(this.getErrorStatus!= 99999)" theme="info" @click="this.ignoreError">{{this.$t('global.common.ignoreError', { defaultValue: '忽略异常' })}}</vButton>

				<vButton class="margin-right-10" @click="close">{{alertbox?'关闭':'返回'}}</vButton>
			</div>
		</compWrapper>
		<vLoading size="large" transfer :loading="loading"></vLoading>
        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
			@on-confirm="modalProps.show=false"
		>
			<component
				v-if="modalProps.component"
				:is="modalProps.component"
				v-bind="modalProps.props"
				@on-close="modalProps.show=false"
				v-on="modalProps.on"
			/>
		</compModal>
    </div>
</template>

<script>
import compErpsku from './erpsku'
// 先引入客户端才引入管理端
import {
	HttpGetWorkDetailOne,
	HttpCreateWorkDetailOne,
	HttpUpdateWorkDetailOne,
	HttpsaveAndSubmitWorkDetailOne,
	HttpWorkDetailListCheck,
	HttpWorkDetailListComplete,
	HttpImportWorkDetail,
	HttpGetLineAndWarehouse,
	HttpWorkTypeList,
	HttpRepushWarehouse,
	HttpAttachRepushWarehouse,
	HttpDeleteAttach,
	HttpGetExcelDetail,
	HttpFindWorkType,
    HttpReprocessError,
    HttpIgnoreError,
	HttpWorkRevokeAudit
} from "@/service/workorder";

import mixin from '../mixin'
import { mapState, mapGetters } from "vuex";
import compImport from './addexcel'

export default {
    mixins: [mixin],
    props:['activeid','querytype','differencetype','alertbox'],
    components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
		compUpload: () => import("@components/templates/upload"),
		compModal: () => import("@components/templates/modal"),
        compLog: () => import("@components/templates/log"),
		compErpsku,
		compImport,
	},
    data(){
        return {
			type: this.$route.params.type,
			id: this.$route.query.id,
			difference: this.$route.query.difference,
			loading:false,
			formData:{},
			workList:[],
			workData:{
				remark:'',
			},
            modalProps: {
				show: false,
				formdata: null,
			},
			workLinename:'',
			dataList:[],
			workdataList:[],
			required: [{
                required: true,
                message: "该信息不能为空,请填写"
			}],
			opLogList:[],
			checkInfo:false,
			compeleteInfo:false,
			excelmodel:null,
			orgId:'',
            photoData: {}
        }
    },
    created(){
		this.update()
		this.checkInfo = this.handleAuth('fbb.workorderplan.check');
		this.compeleteInfo = this.handleAuth('fbb.workorderplan.complete');

		// console.log(this.checkInfo,this.compeleteInfo)
    },
    computed:{
		...mapGetters('dictionary',['getProductList','getTransferWarehouse','getWorkTypeList','getWorkTypeManageList','getBillcusorgList','getCusproductList','getAllExcelModels','getAllExcelTypes']),
		productlist(){
			if(this.type == 'query'){
				return [{value:0,label:'--'},...this.getProductList]
			}else{
				return this.getProductList
			}
		},
		cusproductlist(){
			if(this.type == 'query'){
				return [{value:0,label:'--'},...this.getCusproductList]
			}else{
				return this.getCusproductList
			}
		},
        getBase(){
            return [
                {
                    label: '事务处理计划单号',
                    key: "workOrderPlanNo",
                    required:false,
                    query:this.type!='add',
                    show:this.type!='add',
                    valueText:this.formData.errorStatus<99999 ? this.formData.workOrderPlanNo + '<span class="color-error"> '+this.findRenderLabel(this.errorStatusList, this.formData.errorStatus) || '-sdsf-'+'</span>' : this.formData.workOrderPlanNo,
                },
                {
                    label: '状态',
                    key: "workOrderPlanStatus",
                    tag:'vSelect',
                    options:this.orderStatusList,
                    required:false,
                    query:this.type!='add',
                    show:this.type!='add',
                },
                {
                    label: '关联单据类型',
                    key: "relationOrderTypeId",
                    tag:'vSelect',
                    options:this.getContactOrderList,
                    required:false,
                },
                {
                    label: '关联单据号',
                    key: "orderNo",
					required:false,
					on:{
						'on-blur':(val)=>{
							this.getlineandwarehouse()
						}
					}
                },
                {
					label: '仓库',
					show:this.type != 'query',
                    key: "orgWarehouseId",
                    tag:'vSelect',
					options:this.getTransferWarehouse,
					props:{
						filterable:true
					},
					on: {
                        'on-change': (val) => {
                            this.getWorkType(val);
                        }
                    }
				},
				{
					label: '仓库',
					show:this.type == 'query',
                    valueText:this.formData.orgWarehouseCode+' ('+this.formData.orgWarehouseTitle+')',
                },
                {
                    label: '来源单号',
                    key: "sourceNo",
                    required:false,
                },
                {
                    label: '项目',
                    key: "lineId",
                    tag:'vSelect',
                    options:this.difference=='detail' ? this.productlist : this.cusproductlist,
					required:false,
					props:{
						filterable:true
					}
                },
                {
                    label: '备注',
                    key: "remark",
                    tag:'vTextarea',
                    required:false,
                },
            ]
        },
        columns() {
			let arr = [
				{
					type: 'selection',
					formName: 'workOrderTypeId',
					width: this.type === 'query' ? 0 : 60
				}, {
					title: "No.",
					type: 'index'
				}, {
					title: "事务项",
					render: (h, { row }) => this.findRenderLabel(this.workList, row.workOrderTypeId),
				},
				{
					title: "事务项",
					render: (h, { row }) => this.findRenderLabel(this.workList, row.workOrderTypeId),
				},
				{
					title: "ERP SKU",
					key: 'sku'
				}, {
					title: this.$t('fbb.inbound.planned_quantity', { defaultValue: '计划数量' }),
					key: 'qty'
				},{
					title: "备注",
					key: 'remark'
				},
			]
			if(this.difference == 'detail'){
				arr.splice(3,1)
			}else{
				arr.splice(2,1)
			}
			if(this.formData.workOrderPlanStatus == 20 || this.formData.workOrderPlanStatus == 30 || this.formData.workOrderPlanStatus == 70){
				let data = {
					title: '已处理数量',
					key: 'completeQty'
				}
				arr.splice(5,0,data)
			}
			return arr
		},
		workcolumns(){
			return[
				{
					type: 'selection',
					formName: 'id',
					width: this.formData.workOrderPlanStatus == 0 || this.formData.workOrderPlanStatus == 10 || this.formData.workOrderPlanStatus == 15 || this.formData.workOrderPlanStatus == 20 || this.type=='add' ? 60 : 0
				},
				{
					title: "No.",
					type: 'index',
					width: 60,
				}, {
					title: "附件类型",
					width: 100,
					render: (h, { row }) => this.findRenderLabel(this.getAllExcelTypes, row.typeId),
				},{
					title: "附件名称",
					width: 100,
					key: 'filename'
				},{
					title: "附件链接",
					key: 'url',
					render:(h,{row})=>{
						return h('div', [
							h('a', {
								props: {
									type: "primary",
									size: 'small'
								},
								style: {
									marginRight: '5px'
								},
								on: {
									click: () => {
										this.handleDownload(row.url)
									}
								}
							}, row.url),
						])
					}
				}, {
					title: "创建时间",
					key: 'createdAt',
					width: 140,
				},
			]
		},
		getLogcolumns(){
			return [
				{
					title: "操作人",
					key: 'opName'
				}, {
					title: "操作类型",
					key: 'opType'
				},{
					title: "操作原因",
					key: 'remark'
				}, {
					title: "操作时间",
					key: 'opAt'
				},
			]
		},
        getErrorStatus() {
            // console.log(this.formData);
            return this.type !== 'add' && this.formData.errorStatus
        },
    },
    methods:{
		handleDownload(url){
			this.handleWebfs(url, 'download')
		},
		checkWarehouse(){
			if(!this.formData.orgWarehouseId){
				this.$VMessage.error("请先选择仓库！")
			}
		},
        resetNumber(){
            this.workData.qty={}
        },
		getWorkType(orgWarehouseId){
			this.workList = [];
			HttpFindWorkType({
                contextId:global.SYSID,
                orgWarehouseId: orgWarehouseId,
            }).then(
                (res) => {
                    this.workList = res.data.map(item => {
                        return {
                            value: item.id,
                            label: `${item.transactionCode}(${item.transactionName})`,
                            attach: {
                                ...item
                            }
                        }
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
		},
		// 重推仓库
		repushware(){
			HttpRepushWarehouse({
				id:this.id
			}).then(res=>{
				this.$VMessage.success(res.message)
			},err=>{
				this.$VMessage.error(err.message)
			})
		},
		// 重推附件
		repushattach(){
			HttpAttachRepushWarehouse({
				id:this.id
			}).then(res=>{
				this.$VMessage.success(res.message)
			},err=>{
				this.$VMessage.error(err.message)
			})
		},
		// 根据单据号带出项目和仓库
		getlineandwarehouse(){
			HttpGetLineAndWarehouse({
				orderType:this.formData.relationOrderTypeId,
				orderNo:this.formData.orderNo
			}).then(res=>{
				this.$set(this.formData,'lineId',res.data.lineId)
				this.$set(this.formData,'orgWarehouseId',res.data.orgWarehouseId)
				this.getWorkType(this.formData.orgWarehouseId)
			},err=>{
				this.$VMessage.error(err.message)
			})
		},
		handleCheckData(rows, val) {
			// console.log(rows,val)
			this.checkedData = rows;
		},
		handleExcelCheckData(rows, val){
			// console.log(rows,val)
			this.ExcelcheckedData = val;
		},
		//上传数据
		handleUploadData() {
			if(!this.formData.orgWarehouseId){
				this.$VMessage.error("请先选择仓库！")
			}else{
				this.modalProps = {
					show: true,
					title: this.$t('global.common.import', { defaultValue: '导入数据' }),
					component: "compUpload",
					showFooter: false,
					width: "middle",
					props: {
						data: {
							workOrderPlanId:this.id?this.id:null,
							orgWarehouseId:this.formData.orgWarehouseId
						},
						name: "multipartFile",
						ajaxRequest: HttpImportWorkDetail,

						download: () => {
							this.handleWebfs("/static/template/workorder.xlsx", {}, {
								executor: 'download',
								type: 'url'
							});
						},
					},
					on: {
						'on-success': (row) => {
							Object.values(row.data || []).forEach((item) => {
								this.addItem(item);
							})
							this.modalProps.show = false;
						}
					},
				}
			}
		},
        //查询ERPSKU
		handleSkuErp() {
			this.modalProps = {
				show: true,
				title: 'SKU',
				component: "compErpsku",
				showFooter: false,
				width: 1000,
				props: {
					initFormData: {
						"search[EQ_lineId]": this.formData.lineId
					}
				},
				on: {
					'on-data': (row) => {
						// console.log(this.workData.workLinename)
						// const { id: productId = "", sku = "",} = row;
						this.workData = { qty: this.workData.qty, sku:row.sku, workOrderTypeId:this.workData.workOrderTypeId, remark:this.workData.remark};
						this.modalProps.show = false;
					}
				},
			}
		},
        addItem(data) {
			let { sku, qty, workOrderTypeId, remark } = data;

			if (!(workOrderTypeId && qty)) {
				this.$VMessage.warning('事物项和数量必填');
				return;
			}
			//xxx
			if(!sku){
				sku = ''
			}
			if(!remark){
				remark = ''
			}

			// let newarr = [];
			let newmap = {};
			let newkey = workOrderTypeId + '_' + sku;

			this.dataList.map(item=>{
				let sku = item.sku;
				let remark = item.remark;
				if(!sku){
					sku = ''
				}
				if(!remark){
					remark = ''
				}
				let allkey = item.workOrderTypeId + '_' + sku;
				// newarr.push(allkey)
				newmap[allkey] = item
			})
			// console.log(newarr,newmap)
			if(newmap.hasOwnProperty(newkey)){
				newmap[newkey].qty += qty;
				if(newmap[newkey].remark==''){
					newmap[newkey].remark = remark
				}
			}else{
				this.dataList.push(data)
			}

			this.workData = { qty: '', sku: '', workOrderTypeId:'', remark:'' };
			return;

		},
		clearAll() {
			this.modalProps = {
				show: true,
				title: this.$tc('global.common.clear', 1, { defaultValue: '清空所有' }),
				alert: 'error',
				ajaxRequest: async () => {
					this.dataList = [];
					return { message: this.$t('global.common.haveto_empty', { defaultValue: '已清空' }) };
				}
			}
		},
		removeItems() {
			// console.log(this.checkedData)
			const checkedData = this.checkedData;
			if (!checkedData.length) {
				this.$VMessage.warning(this.$t('global.common.choose', { defaultValue: '请选择产品' }));
				return
			}

			let newarr = [],checkarr=[],newdatalist=[];
			let newmap = {};
			this.dataList.map(item=>{
				let allkey = item.workOrderTypeId + '_' + item.sku
				newmap[allkey] = item
				newarr.push(allkey)
			})
			checkedData.map(json=>{
				let allkey = json.workOrderTypeId + '_' + json.sku
				checkarr.push(allkey)
			})
			this.modalProps = {
				show: true,
				title: this.$t('global.common.delete', { defaultValue: '删除' }),
				alert: 'warning',
				ajaxRequest: async () => {
					newarr = newarr.filter((row=>{
						return checkarr.indexOf(row) == -1
					}))
					newarr.map(data=>{
						newdatalist.push(newmap[data])
					})
					this.dataList = newdatalist
					return { message: this.$t('global.common.have_deleted', { defaultValue: '已删除' }) };
				}
			}

		},
		update(){
			if(this.querytype){
                this.id = this.activeid
				this.type = this.querytype
				this.difference = this.differencetype
            }else{
                this.id = this.$route.query.id
				this.type = this.type
				this.difference = this.difference
			}
			if(this.type == 'add') return
			this.loading = true;
			this.excelmodel = this.getAllExcelModels.filter(item=> {return item.label == 'workorder'})[0] || {}
			// console.log(this.excelmodel)

			// 请求订单详情
			HttpGetWorkDetailOne({
				id:this.id
			}).then(res=>{
				this.formData = res.data
				this.dataList = res.data.serviceWorkOrderPlanItemModelList
				this.opLogList = res.data.orderLogModelList
				this.orgId = res.data.organizationId     ;
                this.photoData.orderData = this.formData;
                this.photoData.orderType = 11;
				// 获取附件详情
				HttpGetExcelDetail({
					'search[EQ_modelId]':this.excelmodel.value,
					'search[EQ_srcLabel]':res.data.workOrderPlanNo,
					contextId:this.difference == 'manage' ? this.orgId : global.SYSID,
				}).then(res=>{
					this.workdataList = res.data
				},err=>[
					this.$VMessage.error(err.message)
				])
				this.getWorkType(res.data.orgWarehouseId)
				this.loading = false;
			},err=>{
				this.loading = false;
				this.$VMessage.error(err.message)
			})
		},
		addExcel(){
			this.modalProps = {
				show: true,
				title: '上传附件',
				width: 520,
				showFooter: false,
				component: "compImport",
				props:{
					erpskutitle: "ShippingLabel、PackingList、BOL三种类型支持格式为：PNG、JPG、PDF；Other格式不限",
					comptitle: '附件类型',
					actionurl: "/api/v2/ServiceWorkOrderPlan/uploadAttach",
					detailid:this.id,
				},
				on:{
					'on-success':(res)=>{
						this.workdataList.push(res.data)
					}
				}
			}
		},
		deleteExcel(){
			const ExcelcheckedData = this.ExcelcheckedData;
			if (!ExcelcheckedData.length) {
				this.$VMessage.warning('请选择附件');
				return
			}
			this.modalProps = {
				show: true,
				title: this.$t('global.common.delete', { defaultValue: '删除' }),
				alert: 'warning',
				ajaxRequest: async () => {
					this.workdataList = this.workdataList.filter((row) => {
						return ExcelcheckedData.indexOf(row.id) == -1
					})
					if(this.type!='add'){
						HttpDeleteAttach({
							ids:ExcelcheckedData.join(','),
							contextId:this.difference == 'manage' ? this.orgId : global.SYSID,
						}).then(res=>{

						},err=>{
							this.$VMessage.error(err.message)
							return
						})
					}
					return { message: this.$t('global.common.have_deleted', { defaultValue: '已删除' }) };
				}
			}

		},
		async submit(){

			const valid = await this.$refs.editform.validate()
            if (!valid) return;

			let warehouse = this.findRenderLabel(this.getTransferWarehouse, this.formData.orgWarehouseId)
			this.formData.orgWarehouseCode = warehouse.split('(')[0]

			let orderarr = [];
			this.workdataList.map(item=>{
				let data={
					id:item.id
				}
				orderarr.push(data)
			})

			if(this.type == 'add'){
				HttpCreateWorkDetailOne({
					...this.formData,
					orderAttachModelList:orderarr,
					serviceWorkOrderPlanItemModelList:this.dataList,
				}).then(res=>{
					this.$VMessage.success(res.message)
					this.cancel()
				},err=>{
					this.$VMessage.error(err.message)
				})
			}else{
				HttpUpdateWorkDetailOne({
					...this.formData,
					orderAttachModelList:null,
					serviceWorkOrderPlanItemModelList:this.dataList,
				}).then(res=>{
					this.$VMessage.success(res.message)
					this.cancel()
				},err=>{
					this.$VMessage.error(err.message)
				})
			}
		},
		async submitexamine(){
			let orderarr = [];
			this.workdataList.map(item=>{
				let data={
					id:item.id
				}
				orderarr.push(data)
			})
			if(this.type!='query'){
				const valid = await this.$refs.editform.validate()
				if (!valid) return;
			}

			if(this.type == 'add'){
				HttpsaveAndSubmitWorkDetailOne({
					...this.formData,
					orderAttachModelList:orderarr,
					serviceWorkOrderPlanItemModelList:this.dataList,
				}).then(res=>{
					this.$VMessage.success(res.message)
					if(this.alertbox == 'alertbox'){
						this.update()
					}else{
						this.cancel()
					}
				},err=>{
					this.$VMessage.error(err.message)
				})
			}else{
				HttpsaveAndSubmitWorkDetailOne({
					...this.formData,
					orderAttachModelList:null,
					serviceWorkOrderPlanItemModelList:this.dataList,
				}).then(res=>{
					this.$VMessage.success(res.message)
					if(this.alertbox == 'alertbox'){
						this.update()
					}else{
						this.cancel()
					}
				},err=>{
					this.$VMessage.error(err.message)
				})
			}
		},
		examine(){
			const _this = this
			this.modalProps = {
				show: true,
				alert: "primary",
				title: "审核",
				showDesc:false,
				width: 460,
				params:{id:this.id},
				formdata: [
					{
						tag: "vRadio",
						key: "status",
						label:'审核选项',
						options: [{
							trueValue: 1,
							label: '审核通过'
						}, {
							trueValue: 0,
							label: '审核拒回'
						}],
						span: 24,
					},
					{
						tag: "vTextarea",
						key: "remark",
						span: 24,
						label: "备注原因",
						required:false,
					}
				],
				ajaxRequest:HttpWorkDetailListCheck,
				callback: (value) => {
					this.update()
				}
			}

		},
		compelete(){
			this.modalProps = {
				show: true,
				alert: "primary",
				title: "完成",
				showDesc:false,
				width: 460,
				params:{id:this.id},
				formdata: [
					{
						tag: "vTextarea",
						key: "remark",
						span: 24,
						label: "备注原因",
						required:false,
					}
				],
				ajaxRequest:HttpWorkDetailListComplete,
				callback: (value) => {
					this.update()
				}
			}
		},
		cancel(){
			if(this.difference == 'detail'){
				this.$router.push({
					name: 'workorderdetail',
				});
			}else{
				this.$router.push({
					name: 'workordermanage',
				});
			}
		},
		revokeAudit(){
			this.modalProps = {
				show: true,
				alert: "error",
				title: "撤销审核",
				showDesc:true,
				width: 460,
				params:{id:this.id},
				ajaxRequest:HttpWorkRevokeAudit,
				callback: (value) => {
					this.update()
				}
			}
		},
		close(){
			if(this.difference == 'detail'){
				this.$router.push({
					name: 'workorderdetail',
				});
			}else if(this.difference == 'manage'){
				this.$router.push({
					name: 'workordermanage',
				});
			}
			this.$emit('on-close')
		},
        errorReprocess() {
            this.modalProps = {
                show: true,
                title: this.$t('global.common.reprocess', { defaultValue: '重处理' }),
                alert: "info",
                params: { id: this.id },
                ajaxRequest: HttpReprocessError,
                callback: (value) => {
                    this.update();
                }
            }
        },
        ignoreError() {
            this.modalProps = {
                show: true,
                title: this.$t('global.common.ignoreError', { defaultValue: '忽略异常' }),
                alert: "info",
                params: { id: this.id },
                ajaxRequest: HttpIgnoreError,
                callback: (value) => {
                    this.update();
                }
            }
        },
    },

}

</script>
